<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        Search Result
                    </v-card-title>
                    <v-col cols="12" v-if="data_case.status == 'error'">
                        No results found for "<span class="fix-text-error-2">{{
                            search_case
                        }}</span
                        >"
                    </v-col>

                    <v-row v-if="data_case.status == 'ok'">
                        <v-col cols="12">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center" width="2%">
                                                #
                                            </th>

                                            <th class="text-center" width="40%">
                                                Case
                                            </th>
                                            <th class="text-center" width="16%">
                                                Status
                                            </th>
                                            <th class="text-center" width="21%">
                                                Product
                                            </th>
                                            <th class="text-center" width="21%">
                                                Parts
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(row,
                                            index) in data_case.data"
                                            :key="index"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}.
                                            </td>
                                            <td>
                                                <v-chip small color="amber">{{
                                                    row.case_team_name
                                                }}</v-chip>

                                                <v-chip
                                                    small
                                                    color="info"
                                                    class="ml-1 mr-1"
                                                    >{{
                                                        row.project_name
                                                    }}</v-chip
                                                >
                                                <v-btn
                                                    class="mt-1 mb-1 mr-1"
                                                    :to="
                                                        '/Project/ViewCasepending/' +
                                                            row.team_filter +
                                                            '/' +
                                                            row.maincase_id +
                                                            '/ViewDetail'
                                                    "
                                                    target="_blank"
                                                    small
                                                    color="white"
                                                    rounded
                                                >
                                                    <span
                                                        :class="
                                                            row.case_id !=
                                                                'return-pickup' &&
                                                            row.case_id !=
                                                                'return'
                                                                ? 'primary--text mr-1'
                                                                : 'green--text mr-1'
                                                        "
                                                        >{{
                                                            row.case_id +
                                                                "-" +
                                                                row.subcase
                                                        }}
                                                    </span>

                                                    <span
                                                        class="teal--text"
                                                        v-if="
                                                            row.case_id !=
                                                                'return-pickup' &&
                                                                row.case_id !=
                                                                    'return'
                                                        "
                                                    >
                                                        {{
                                                            row.created_date
                                                        }}</span
                                                    >
                                                </v-btn>
                                                <br />
                                                <v-chip
                                                    class="mt-1 mb-1 mr-1"
                                                    small
                                                    v-if="
                                                        row.case_id !=
                                                            'return-pickup' &&
                                                            row.case_id !=
                                                                'return'
                                                    "
                                                    >{{ row.site_name }}</v-chip
                                                >
                                                <v-chip
                                                    v-if="row.case_refer"
                                                    small
                                                    color="primary"
                                                    >{{
                                                        row.case_refer
                                                    }}</v-chip
                                                >
                                                <br />
                                                <span class="fix-bb">{{
                                                    row.case_title
                                                }}</span>
                                                <br v-if="row.remark" />
                                                <span
                                                    class="fix-b3"
                                                    v-if="row.remark"
                                                    >{{ row.remark }}</span
                                                >
                                            </td>

                                            <td>
                                                <v-tooltip bottom>
                                                    <template
                                                        v-slot:activator="{
                                                            on,
                                                        }"
                                                    >
                                                        <v-btn
                                                            :color="
                                                                row.main_status_color
                                                            "
                                                            fab
                                                            dark
                                                            v-on="on"
                                                            x-small
                                                            elevation="0"
                                                        >
                                                            <v-icon small>{{
                                                                row.main_status_icon
                                                            }}</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{
                                                        row.main_status_name
                                                    }}</span>
                                                </v-tooltip>
                                                <span
                                                    class="ml-2 font-weight-medium"
                                                >
                                                    {{ row.sub_status_name }}
                                                </span>
                                                <p
                                                    v-if="
                                                        row.project_name ==
                                                            'CDAX'
                                                    "
                                                    class="mt-2 font-weight-medium"
                                                >
                                                    CDAX :
                                                    {{ row.status_name }}
                                                </p>
                                            </td>

                                            <td>
                                                <v-chip
                                                    small
                                                    color="indigo white--text"
                                                    >{{
                                                        row.product_serial
                                                    }}</v-chip
                                                >
                                                <br />
                                                <span class="fix-bb">
                                                    {{
                                                        row.product_description
                                                    }}
                                                </span>
                                            </td>

                                            <td>
                                                <div v-if="row.parts">
                                                    <span
                                                        v-for="(r,
                                                        i) in row.parts"
                                                        :key="i"
                                                    >
                                                        <span
                                                            class="mr-1 fix-b1"
                                                            >{{ i + 1 }}.</span
                                                        >
                                                        <span
                                                            class="mr-1 fix-b1"
                                                            v-if="r.ponumber"
                                                            >{{ r.ponumber }}
                                                        </span>
                                                        <span
                                                            class="mr-1 fix-b1"
                                                            >{{ r.part_name }}
                                                        </span>
                                                        <span
                                                            class="mr-1 fix-b1"
                                                            >{{
                                                                r.part_description
                                                            }}</span
                                                        >

                                                        <span
                                                            class="mr-1 fix-b1"
                                                            >{{
                                                                r.singlepart
                                                            }}</span
                                                        >
                                                        <span
                                                            class="mr-1 fix-b1"
                                                            v-if="r.rma"
                                                            >{{ r.rma }}</span
                                                        >

                                                        <span
                                                            class="mr-1 fix-b1"
                                                            v-if="r.singlepart"
                                                            >{{
                                                                r.singlepart
                                                            }}</span
                                                        >

                                                        <span
                                                            :class="
                                                                r.ce_status ==
                                                                'Good'
                                                                    ? 'mr-1 fix-b2'
                                                                    : 'mr-1 fix-b22'
                                                            "
                                                            >{{
                                                                r.ce_status
                                                            }}</span
                                                        >
                                                        <hr
                                                            style="border: 1px dashed grey;"
                                                            v-if="
                                                                row.parts
                                                                    .length -
                                                                    1 !=
                                                                    i
                                                            "
                                                        />
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import TableViewCase from "../../pages/Project/components/TableViewCase"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    components: {
        "table-view-case": TableViewCase,
    },
    watch: {
        "$route.params.search": function(val) {
            this.search_case = val
        },
        "$route.query.q": function(val) {
            this.chk_status = val.status
            this.data_case = val
            if (this.data_case.data.length == 1) {
                this.$router.push(
                    "/Project/ViewCasepending/" +
                        this.data_case.data[0].team_filter +
                        "/" +
                        this.data_case.data[0].maincase_id +
                        "/" +
                        "ViewDetail"
                )
            }
        },
    },
    mounted() {
        // this.search_case = this.$route.params.search
        this.data_case = this.$route.query.q
        if (this.data_case === "[object Object]") {
            this.$router.push("/")
        }

        if (this.data_case.data.length == 1) {
            this.$router.push(
                "/Project/ViewCasepending/" +
                    this.data_case.data[0].team_filter +
                    "/" +
                    this.data_case.data[0].maincase_id +
                    "/" +
                    "ViewDetail"
            )
        }
    },
    data() {
        return {
            search_case: this.$route.params.search,
            chk_status: "",
            casetab: true,
            data_case: [],
        }
    },
}
</script>
<style scoped>
.fix-text-error {
    color: rgb(35, 42, 61) !important;
    font-size: 26px;
    font-weight: bold;
}
.fix-text-error-2 {
    color: rgb(248, 51, 51) !important;
}
.fix-bb {
    font-weight: bold;
    font-size: 12px;
    color: rgb(60, 79, 133) !important;
}

.fix-b1 {
    font-weight: bold;
    font-size: 12px;
    color: rgb(30, 84, 134) !important;
}
.fix-b2 {
    font-weight: bold;
    font-size: 12px;
    color: rgb(0, 214, 11) !important;
}
.fix-b22 {
    font-weight: bold;
    font-size: 12px;
    color: rgb(255, 0, 0) !important;
}
.fix-b3 {
    /* font-weight: bold; */
    font-size: 12px;
    color: rgb(131, 50, 206) !important;
}
.fix-b4 {
    font-weight: bold;
    font-size: 12px;
    color: rgb(58, 58, 58) !important;
}
</style>
